(function () {
    'use strict';

    function init() {
        const container = document.querySelector('.js-image-card-carousel');
        if (!container) return;

        const itemsCount = container.style.getPropertyValue('--items-count');

        setupSwiper('.js-image-card-carousel', {
            containerSelector: '.js-image-card-carousel-container',
            jsSelector: '.js-image-card-carousel',
            swiperOptions: {
                slidesPerView: itemsCount > 1 ? 1.1 : 1,
                spaceBetween: 12,
                breakpoints: {
                    744: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();